import { render, staticRenderFns } from "./CompeteProblemTemplate.vue?vue&type=template&id=18c504f1&scoped=true&"
import script from "./CompeteProblemTemplate.vue?vue&type=script&lang=js&"
export * from "./CompeteProblemTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CompeteProblemTemplate.vue?vue&type=style&index=0&id=18c504f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c504f1",
  null
  
)

export default component.exports